// generates the queries service that is passed into custom qRules commands

const convertPerson = ({ AccountId, DisplayName }) => ({
    userName: AccountId,
    displayName: DisplayName,
});

const searchPeople =
    (peopleSearcher) =>
    async (searchText, { includeGroups = false, maxCount = 200 } = {}) => {
        const people = await peopleSearcher.searchPeople(
            searchText,
            !includeGroups, // peopleOnly
            maxCount,
        );

        return people.map(convertPerson);
    };

const makeCustomCommandQueryService = (peopleSearcher) => ({
    searchPeople: searchPeople(peopleSearcher),
});

export default makeCustomCommandQueryService;
